/**
 * ConvoCX brand mark — the Chat Bubble logo (design-system-v1).
 *
 * This is the ONLY approved logo (logos/chat-bubble.svg). The exact artwork is
 * inlined here for crisp scaling per the brand guidelines. The white body/dots
 * are visible on any surface; on the primary colour use the swapped variant.
 */
/** Chat Bubble mark at a square display size (fitted within `size` px). */
export function ChatBubbleLogo({ size = 40 }: { size?: number }) {
  const h = Math.round((size * 343) / 274);
  return (
    <svg
      width={size}
      height={h}
      viewBox="0 0 274 343"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="ConvoCX"
      style={{ display: 'block' }}
    >
      <path
        d="M172.24 57H81.76C58.6966 57 40 77.0935 40 101.88V199.12C40 223.907 58.6966 244 81.76 244H172.24C195.303 244 214 223.907 214 199.12V101.88C214 77.0935 195.303 57 172.24 57Z"
        fill="#ffffff"
      />
      <path
        d="M64.9923 73.5923C45.7886 92.796 35.0001 118.842 35.0001 146C32.3649 166.227 35.8305 186.78 44.9526 205.024C54.0747 223.268 68.4376 238.372 86.2001 248.4V299.6L137.4 248.4C164.558 248.4 190.604 237.611 209.808 218.408C229.012 199.204 239.8 173.158 239.8 146C239.8 118.842 229.012 92.796 209.808 73.5923C190.604 54.3885 164.558 43.6 137.4 43.6C110.242 43.6 84.196 54.3885 64.9923 73.5923Z"
        stroke="#7c5cfc"
        strokeWidth="40.96"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M137.4 166.48C148.711 166.48 157.88 157.311 157.88 146C157.88 134.689 148.711 125.52 137.4 125.52C126.089 125.52 116.92 134.689 116.92 146C116.92 157.311 126.089 166.48 137.4 166.48Z" fill="#ffffff" />
      <path d="M214.2 166.48C225.511 166.48 234.68 157.311 234.68 146C234.68 134.689 225.511 125.52 214.2 125.52C202.889 125.52 193.72 134.689 193.72 146C193.72 157.311 202.889 166.48 214.2 166.48Z" fill="#ffffff" />
      <path d="M60.6001 166.48C71.9109 166.48 81.0801 157.311 81.0801 146C81.0801 134.689 71.9109 125.52 60.6001 125.52C49.2893 125.52 40.1201 134.689 40.1201 146C40.1201 157.311 49.2893 166.48 60.6001 166.48Z" fill="#ffffff" />
    </svg>
  );
}

/** Wordmark: "Convo" 600 + "CX" 800 (never unify). */
export const CONVOX_WORDMARK = (
  <span style={{ fontFamily: 'Inter, sans-serif', fontSize: 18, letterSpacing: '-0.4px', color: 'var(--color-text-primary)' }}>
    <span style={{ fontWeight: 600 }}>Convo</span>
    <span style={{ fontWeight: 800 }}>CX</span>
  </span>
);
